import { USER_ROLE } from "data/constants";
import { memo } from "react";

const data = [
  { key: USER_ROLE.SUPERADMIN, label: "Superadmin" },
  { key: USER_ROLE.SALE, label: "Sale" },
  { key: USER_ROLE.SERVICE, label: "Service" },
  { key: USER_ROLE.MANAGER, label: "Manager" },
  { key: USER_ROLE.SAFETY, label: "Safety" },
];

export default data;

export const UserRole = memo(({ value }) => {
  const label = data.find((f) => f.key === value)?.label ?? "";
  let className = ["badge p-2 mr-1"];

  switch (value) {
    case USER_ROLE.SUPERADMIN:
      className.push("badge-danger");
      break;
    case USER_ROLE.SALE:
      className.push("badge-primary");
      break;
    case USER_ROLE.SERVICE:
      className.push("badge-warning");
      break;
    case USER_ROLE.MANAGER:
      className.push("badge-info");
      break;
    case USER_ROLE.SAFETY:
      className.push("badge-success");
      break;
  }

  return <span className={className.join(" ")}>{label}</span>;
});
